import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://testimonialshub.com";

const BRAND_NAME =
  process.env.REACT_APP_BRAND_NAME || "TestimonialsHub";

const DEFAULT_TITLE =
  "TestimonialsHub - Collect Text & Video Testimonials";

const DEFAULT_DESCRIPTION =
  "TestimonialsHub helps businesses collect, manage, and display text and video testimonials with beautiful Wall of Love widgets.";

const DEFAULT_IMAGE = `${SITE_URL}/brand/og-image.png`;

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  keywords = "testimonial software, video testimonial software, testimonial collection platform, wall of love widget, collect customer testimonials, testimonial embed widget",
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  noindex = false,
}) {
  const finalTitle = title.includes(BRAND_NAME)
    ? title
    : `${title} | ${BRAND_NAME}`;

  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{finalTitle}</title>

      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta
        name="robots"
        content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"}
      />

      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
